export enum ActionStateEnum {
  VIEW = 'VIEW',
  HIDE = 'HIDE',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  TRANSLATE = 'TRANSLATE',
  DELETE = 'DELETE',
  MODAL = 'MODAL'
}
